import React from "react";
function NojoomBannerShimmer(){
    return(
    <div className="shimmer-effect shimmerBG mb-4" style={{height: 415}}> </div>
    )
}

export default NojoomBannerShimmer;